import { Role } from '../types/FirestoreUser'
import useFirestoreUser from './useFirestoreUser'

export default function useIsRole(role: Role): boolean {
  const user = useFirestoreUser()
  // Ensure roles array exists before calling includes
  if (!user || !Array.isArray(user.roles)) {
    return false
  }
  return user.roles.includes(role)
}
